export default "__VITE_ASSET__7af5e640__"